import * as React from 'react';
import {
    bidderPreferenceLoadedSelector,
    bidderPreferenceSelector,
    updateBidderPreferences,
} from '@/redux/modules/bidderPreference';
import { getPreferredCurrencyCookie, setPreferredCurrencyCookie } from '@/utils/cookies';
import { useDispatch, useSelector } from 'react-redux';
import AnchoredPopover from '@liveauctioneers/caterwaul-components/lib/Popover/AnchoredPopover';
import { currencies } from '@/enums';
import CurrencySelection from './CurrencySelection';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getProfileUrl } from '@/utils/urls';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

//1 min
const timeToDisplay = 60000;

const CurrencySelectionPopover = () => {
    const dispatch = useDispatch();
    let location = useLocation();
    const bidderPreferences = useSelector(bidderPreferenceSelector);
    const bidderPreferenceLoaded = useSelector(bidderPreferenceLoadedSelector);
    const [show, setShow] = React.useState(false);
    const cookie = getPreferredCurrencyCookie();

    const onClose = React.useCallback(() => {
        setPreferredCurrencyCookie();
        dispatch(
            updateBidderPreferences({
                ...bidderPreferences,
                preferredCurrency: currencies.NoCurrency,
            })
        );
        setShow(false);
    }, [dispatch, bidderPreferences]);

    React.useEffect(() => {
        if (!cookie && Boolean(bidderPreferenceLoaded)) {
            if (bidderPreferences.preferredCurrency !== currencies.NoCurrency) {
                setPreferredCurrencyCookie();
                setShow(false);
            } else {
                setShow(true);
                window.setTimeout(() => setShow(false), timeToDisplay);
            }
        }
    }, [bidderPreferenceLoaded, bidderPreferences, cookie]);

    //never render on the profile page, checkout, or bidding console
    if (
        location?.pathname === getProfileUrl() ||
        location?.pathname.startsWith('/checkout') ||
        location?.pathname.startsWith('/console')
    ) {
        return null;
    }

    return (
        <AnchoredPopover bottom={25} right={25} show={show}>
            <StyledCurrencySelectionPopover>
                <StyledPopoverHeader>
                    <h3>
                        <FormattedMessage id="preferredCurrencyConversion.changeCurrency" />
                    </h3>
                    <StyledPopoverClose icon={faTimes} onClick={onClose} />
                </StyledPopoverHeader>
                <CurrencySelection />
            </StyledCurrencySelectionPopover>
        </AnchoredPopover>
    );
};

export default CurrencySelectionPopover;

const StyledCurrencySelectionPopover = styled.div`
    padding: 15px;
    width: 250px;
    background-color: ${({ theme }) => theme.colors.beige100};
`;

const StyledPopoverHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
`;

const StyledPopoverClose = styled(FontAwesomeIcon)`
    cursor: pointer;
    && {
        width: 20px;
        height: 20px;
    }
`;
